import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { caseStudyFields } from '../../../../assets/content/case-study-fields.json';
import { FormValidationService } from 'src/app/services/form-validation.service';
import { Utils } from 'src/utils';
import { GlowService } from 'src/app/services/glow.service';
@Component({
  selector: 'app-form-template',
  templateUrl: './form-template.component.html',
  styleUrls: ['./form-template.component.scss'],
})
export class FormTemplateComponent implements OnInit {
  @Input() formGroup: FormGroup;
  caseStudyFields = caseStudyFields;
  @Input() title;
  @Input() categories: [];
  @Input() completionStatus: string;
  remainingCharactersMap = {};
  constructor(
    private formValidationService: FormValidationService,
    private glowService: GlowService,
  ) {}

  ngOnInit() {
    this.setImageSources().then();
  }

  checkFormValidity(formControlName, translateKey?) {
    const formValidity = this.formValidationService.checkFormValidity(this.formGroup, formControlName, translateKey);
    return formValidity;
  }

  async setImageSources() {
    for (let category of this.categories) {
      for (let field in this.caseStudyFields[category] as any) {
        const info: any = this.caseStudyFields[category][field];
        if (info.type != 'file') continue;
        let files = this.formGroup.get(field).value;
        if (!files) continue;
        // if (!info.multiple) {
        //   files = [files];
        // }
        if (!Array.isArray(files)) {
          files = [files];
        }
        for (let i = 0; i < files.length; i++) {
          if (!files[i].fileId) {
            const fileDimensions = await Utils.getFileDimensions({ file: files[i] });
            files[i].width = fileDimensions.width;
            files[i].height = fileDimensions.height;
            await this.setImageSourceAndClass(files[i], field + i + this.formGroup.metadata.componentId, { width: files[i].width, height: files[i].height });
          } else {
            const blob = await this.glowService.getImage(files[i].fileId);
            if (blob) {
              await this.setImageSourceAndClass(blob, field + i + this.formGroup.metadata.componentId, { width: files[i].width, height: files[i].height });
            }
          }
        }
      }
    }
  }

  async addDescriptionToImage(event, controlName, index) {
    let files = this.formGroup.get(controlName).value;
    let description = event.target.value;
    if (!(files && files[index])) return;
    files[index].description = description;
    this.formGroup.get(controlName).setValue(files);
  }

  async removeImage(controlName, index) {
    const dt = new DataTransfer();
    const fileList = this.formGroup.get(controlName).value;
    fileList.splice(index, 1);
    this.formGroup.get(controlName).setValue(fileList);
    this.formGroup.get(controlName).updateValueAndValidity();

    for (let i = 0; i < fileList.length; i++) {
      if (fileList[i] instanceof File) {
        dt.items.add(fileList[i]);
      }
    }
    if (dt.files.length) {
      const elem = document.getElementById(controlName) as HTMLInputElement;
      elem.files = dt.files;
    }

    // Ensure the first image is active after removal
    const carouselElement = document.getElementById(controlName + 'multipleImages');
    if (carouselElement) {
      const activeItems = carouselElement.querySelectorAll('.carousel-item.active');
      activeItems.forEach(item => item.classList.remove('active'));
      const firstItem = carouselElement.querySelector('.carousel-item');
      if (firstItem) {
        firstItem.classList.add('active');
      }
    }

  }

  getRemainingCharacters(controlName, maxLength) {
    if (!maxLength) return;
    const control = this.formGroup.get(controlName);
    this.remainingCharactersMap[controlName] = maxLength;
    if (control && control.value) {
      this.remainingCharactersMap[controlName] = maxLength - control.value.length;
    }
    return this.remainingCharactersMap[controlName];
  }

  async setImageSourceAndClass(blob, id, imgInfo) {
    const imgElm = await Utils.waitForElemById(id);
    if (!imgElm) return;
    const scr = (await Utils.getBlobImageSource(blob)) as string;
    const imageOrientation = Utils.getImageOrientation(imgInfo);
    imgElm.setAttribute('class', imageOrientation);
    imgElm.setAttribute('src', scr);
  }

  async fileInputChange(files, controlName, defaultImageDescription) {
    if (!files || files.length == 0) return;
    // ** debug
    const dt = new DataTransfer();

    const existingValue = this.formGroup.get(controlName).value;
    const existingFiles = [];
    if (existingValue && existingValue.length > 0) {
      for (let i = 0; i < existingValue.length; i++) {
        if (existingValue[i].fileId) {
          existingFiles.push(existingValue[i]);
        } else {
          dt.items.add(existingValue[i]);
        }
      }
    }

    for (let i = 0; i < files.length; i++) {
      const fileDimensions = await Utils.getFileDimensions({ file: files[i] });
      files[i].width = fileDimensions.width;
      files[i].height = fileDimensions.height;
      if (defaultImageDescription) files[i].description = defaultImageDescription;
      dt.items.add(files[i]);
    }

    this.formGroup.get(controlName).setValue([...existingFiles, ...Array.from(dt.files)]);
    await this.setImageSources();
  }
}
